/* eslint arrow-body-style: 0 */
import Subaccounts from './Index';
import Wrapper from "../settings/Wrapper";
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/subaccounts'),
    name: 'menu_subaccounts',
    component: Subaccounts,
    roles: ['administrator'],
    accountTypes: ['parent_account']
  },
]